import MarqueeLib from "react-fast-marquee";

const ITEMS = [
  "Identité visuelle",
  "Supports print",
  "Réseaux sociaux",
  "Site web",
  "Signalétique",
  "Accompagnement",
];

const Diamond = () => (
  <span className="mx-10 inline-block h-1.5 w-1.5 rotate-45 bg-champagne/80" aria-hidden="true" />
);

const Marquee = ({ className = "" }) => (
  <div
    className={`border-y border-white/5 bg-noir py-6 ${className}`}
    data-testid="editorial-marquee"
  >
    <MarqueeLib speed={28} gradient={false} pauseOnHover>
      {ITEMS.map((item) => (
        <span key={item} className="flex items-center">
          <span className="font-serif text-2xl font-light italic tracking-wide text-ivoire/80 sm:text-3xl">
            {item}
          </span>
          <Diamond />
        </span>
      ))}
    </MarqueeLib>
  </div>
);

export default Marquee;
